const subwayDisplayOptions = {
  SPLIT: "subwayDisplay_SPLIT",
  SUBWAY: "subwayDisplay_SUBWAY",
  SHOW_ALL: "subwayDisplay_SHOWALL"
};

export default subwayDisplayOptions;

export const labelForSubwayLayout = value => {
  switch (value) {
    case subwayDisplayOptions.SUBWAY:
      return "Subway";
    case subwayDisplayOptions.SPLIT:
      return "Separate";
  }
};

export const descriptionForSubwayLayout = value => {
  switch (value) {
    case subwayDisplayOptions.SUBWAY:
      return "Show related items as intersecting tracks.";
    case subwayDisplayOptions.SPLIT:
      return "Show each track separately.";
  }
};

export const iconForSubwayLayout = value => {
  switch (value) {
    case subwayDisplayOptions.SUBWAY:
      return "footerSubwayLayoutSubway";
    case subwayDisplayOptions.SPLIT:
      return "footerSubwayLayoutSeparate";
  }
};

const createSubwayDisplayDropdownOption = id => {
  return {
    identifier: id,
    name: labelForSubwayLayout(id),
    description: descriptionForSubwayLayout(id),
    icon: iconForSubwayLayout(id)
  };
};

export const SubwayDisplayDropdownOptions = [
  createSubwayDisplayDropdownOption(subwayDisplayOptions.SPLIT),
  createSubwayDisplayDropdownOption(subwayDisplayOptions.SUBWAY)
];
